import constants from './constants';
import getApiHeaders from './apiHeaders.js';

const sendFileChatMessage = async (userMessage, fileId, chatId = null, subject = '') => {
    if (!fileId) {
        throw new Error("File ID is required to fetch messages.");
    }

    if (!userMessage || !userMessage.content || userMessage.role !== 'user') {
        throw new Error('User message is required');
    }

    const userMessageText = userMessage.content.trim();
    if (!userMessageText) {
        throw new Error('User message cannot be empty');
    }

    const requestPayload = {
        message: userMessageText,
        fileId: fileId,
        subject: subject
    };

    // Build URL: include chatId in path only if it's a valid value
    const url = chatId
        ? `${constants.fetchChatById}/${chatId}`
        : `${constants.fetchChatById}`;

    const response = await fetch(url, {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify(requestPayload),
        credentials: "include"
    });

    if (!response.ok) {
        const errorData = await response.json();
        const error = new Error(errorData.error || errorData || 'Failed to fetch chat response');
        error.status = response.status;
        error.message = errorData.error || errorData || error.message;
        throw error;
    }

    const result = await response.json();

    const returnedChatId = result._id || chatId;
    const messages = result.messages || [];

    return {
        messages: messages,
        _id: returnedChatId
    };
}

export default sendFileChatMessage;
